/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldChange } from './FieldChange';
import {
    FieldChangeFromJSON,
    FieldChangeFromJSONTyped,
    FieldChangeToJSON,
    FieldChangeToJSONTyped,
} from './FieldChange';

/**
 * 
 * @export
 * @interface HistoryEntry
 */
export interface HistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof HistoryEntry
     */
    user?: string;
    /**
     * 
     * @type {Date}
     * @memberof HistoryEntry
     */
    modifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof HistoryEntry
     */
    changeReason?: string;
    /**
     * 
     * @type {Array<FieldChange>}
     * @memberof HistoryEntry
     */
    changes: Array<FieldChange>;
}

/**
 * Check if a given object implements the HistoryEntry interface.
 */
export function instanceOfHistoryEntry(value: object): value is HistoryEntry {
    if ((!('modifiedAt' in (value as Record<string, any>)) && !('modified_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['modifiedAt'] === undefined && (value as Record<string, any>)['modified_at'] === undefined)) return false;
    if (!('changes' in value) || value['changes'] === undefined) return false;
    return true;
}

export function HistoryEntryFromJSON(json: any): HistoryEntry {
    return HistoryEntryFromJSONTyped(json, false);
}

export function HistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'] == null ? undefined : json['user'],
        'modifiedAt': (new Date(json['modified_at'])),
        'changeReason': json['change_reason'] == null ? undefined : json['change_reason'],
        'changes': ((json['changes'] as Array<any>).map(FieldChangeFromJSON)),
    };
}

export function HistoryEntryToJSON(json: any): HistoryEntry {
    return HistoryEntryToJSONTyped(json, false);
}

export function HistoryEntryToJSONTyped(value?: HistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': value['user'],
        'modified_at': value['modifiedAt'].toISOString(),
        'change_reason': value['changeReason'],
        'changes': ((value['changes'] as Array<any>).map(FieldChangeToJSON)),
    };
}

